// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"bf6176bf","496":"ed6267a3","703":"4403bda5"}[chunkId] + ".chunk.js";
};